'use client'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

export function GoogleAnalytics() {
  const pathname = usePathname()

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-YKFJJZ39WX', {
        page_path: pathname,
      })
    }
  }, [pathname])

  return null
}
